import moment from 'moment';
import { getFullName } from '../../../../utils';
import { styledDefaultColDef } from '../../../../extras/cellRenderers';

function StartDateGetter(params) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <span style={{ fontSize: 13, color: '#374151' }}>
        {params.data.startDate && moment(params.data.startDate).format('DD MMM YYYY')}
      </span>
    </div>
  );
}

export const cohortColumnDefs = [
  {
    headerName: 'Id',
    field: 'id',
    filter: 'agTextColumnFilter',
    width: 200,
    hide: true,
  },
  {
    headerName: 'Cohort Name',
    field: 'name',
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['contains'],
      // valueGetter: (props) => getFullName(props.data),
      debounceMs: 200,
    },
    width: 200,
  },
  {
    headerName: 'Start Date',
    field: 'startDate',
    filter: 'agDateColumnFilter',
    width: 200,
    filterParams: {
      valueGetter: (props) => moment(props.data?.createdOn),
      debounceMs: 200,
      comparator: (filterLocalDateAtMidnight, cellValue) => {
        const dateAsString = moment(cellValue).format('DD/MM/YYYY');
        if (dateAsString == null) {
          return 0;
        }
        const dateParts = dateAsString.split('/');
        const year = Number(dateParts[2]);
        const month = Number(dateParts[1]) - 1;
        const day = Number(dateParts[0]);
        const cellDate = new Date(year, month, day);

        if (cellDate < filterLocalDateAtMidnight) {
          return -1;
        } else if (cellDate > filterLocalDateAtMidnight) {
          return 1;
        }
        return 0;
      },
    },
    cellRenderer: StartDateGetter,
  },
  {
    field: 'courseType',
  },
  {
    headerName: 'Career Coach',
    field: 'careerCoach',
    valueGetter: (params) => {
      return getFullName(params.data?.careerCoach);
    },

    valueFormatter: (params) => {
      return getFullName(params.data?.careerCoach);
    },
    width: 200,
  },
  {
    headerName: 'Champion',
    field: 'champion',
    valueGetter: (params) => {
      return getFullName(params.data?.champion);
    },
    valueFormatter: (params) => {
      return getFullName(params.data?.champion);
    },
    width: 200,
  },
  {
    headerName: 'Communication Coach',
    field: 'communicationCoach',
    valueGetter: (params) => {
      return getFullName(params.data?.communicationCoach);
    },
    valueFormatter: (params) => {
      return getFullName(params.data?.communicationCoach);
    },
    width: 250,
  },
  {
    headerName: 'Actions',
    field: 'actions',
    cellRenderer: 'btnCellRenderer',
    pinned: 'right',
    sortable: false,
  },
];

export const almaCohortColumnDefs = [
  {
    headerName: 'Name',
    field: 'name',
    filter: 'agTextColumnFilter',
    valueGetter: (props) => getFullName(props.data?.User),
    filterParams: {
      filterOptions: ['contains'],
      valueGetter: (props) => getFullName(props.data?.User),
      debounceMs: 200,
    },
    valueFormatter: (params) => {
      return getFullName(params.data?.User);
    },
    width: 200,
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      const nameA = getFullName(nodeA.data?.User);
      const nameB = getFullName(nodeB.data?.User);
      const comparison = nameA.localeCompare(nameB);
      return comparison;
    },
  },

  {
    headerName: 'Learning Cohort',
    field: 'learningCohort',
    valueGetter: (props) => props.data?.cohortName,
    filterParams: {
      valueGetter: (props) => props.data?.cohortName,
    },
    valueFormatter: (params) => {
      return params.data?.cohortName;
    },
  },
  {
    headerName: 'AlmaX Cohort',
    field: 'almaCohort',
    valueGetter: (props) => props.data?.almaxCohortName,
    filterParams: {
      valueGetter: (props) => props.data?.almaxCohortName,
    },
    valueFormatter: (params) => {
      return params.data?.almaxCohortName;
    },
  },
  {
    headerName: 'Actions',
    field: 'actions',
    cellRenderer: 'btnCellRenderer',
    pinned: 'right',
    sortable: false,
    suppressMenu: true,
  },
];
export const cohortDefaultColDef = {
  ...styledDefaultColDef,
  filter: true,
  flex: 1,
};
